import React from "react";

import CommonButton from "@cayuse/shared-react.components.button";
import PropTypes from "prop-types";
import { Button, Grid, Icon } from "semantic-ui-react";

import IconButton from "@cayuse/shared-react.components.icon-button";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { useDictionary } from "hooks";

import { useRules } from "../../../../useRules";
import RuleGroup from "./RuleGroup";
import RuleModal from "./RuleModal";
import styles from "./styles.css";


const RulesTab = ({ parentQuestionConfig, completeFormModel, onChange, ruleType }) => {
	const {
		common: commonDictionary,
		[ruleType]: ruleDictionary,
	} = useDictionary("simplifiedBuilder.components.RulesTab");

	const {
		groups,
		showRuleSelector,
		setShowRuleSelector,
		ruleExpression,
		addRuleToGroup,
		removeRuleFromGroup,
		addGroup,
		openModalAssignGroupNumber,
		ruleModalProps,
		openRuleSelectorModal,
	} = useRules({ parentQuestionConfig, completeFormModel, onChange, ruleType });

	return (
		<>
			<Grid>
				<Grid.Row className={styles.topRow}>
					<Grid.Column width={12}>{ruleDictionary.topText}</Grid.Column>
					<Grid.Column width={4}>
						<Button onClick={addGroup} className={styles.button}>{commonDictionary.addGroup}</Button>
					</Grid.Column>
				</Grid.Row>
				{groups && groups.map((group, index) => (
					<Grid.Row key={index} className={styles.groupRowContainer}>
						<Grid.Column width={16}>
							{group.length < 1 && (
								<Grid>
									<Grid.Row columns={16}>
										<Grid.Column width={13}>
											<IconButton
												icon="plus"
												className={styles.plusButton}
												onClick={() => openRuleSelectorModal(index)}
											>
												{commonDictionary.addQuestionAndAnswer}
											</IconButton>
										</Grid.Column>
										<Grid.Column width={3} className={styles.deleteEmptyGroup}>
											<CommonButton className={styles.deleteButton} onClick={() => removeRuleFromGroup(index, 0)} aria-label="Delete empty group">
												<Icon name="trash" size="large" className={styles.pointer} />
											</CommonButton>
										</Grid.Column>
									</Grid.Row>
								</Grid>
							)}
							<RuleGroup
								displayRules={group}
								openModalAssignGroupNumber={() => openModalAssignGroupNumber(index)}
								removeRuleFromGroup={childIndex => removeRuleFromGroup(index, childIndex)}
							/>
							{index !== groups.length - 1 && (
								<Grid.Row className={styles.or}>
									<Grid.Column>
										<strong>{commonDictionary.or}</strong>
									</Grid.Column>
								</Grid.Row>
							)}
						</Grid.Column>
					</Grid.Row>
				))}

				<Grid.Row className={styles.expressionRow}>
					{isNonEmptyString(ruleExpression) && (
						<Grid.Column>{commonDictionary.expression}<strong>{ruleExpression}</strong></Grid.Column>
					)}
				</Grid.Row>
			</Grid>

			{showRuleSelector && (
				<RuleModal
					{...ruleModalProps}
					open={showRuleSelector}
					onClose={() => setShowRuleSelector(false)}
					onAddRule={addRuleToGroup}
					ruleType={ruleType}
				/>
			)}
		</>
	);
};

RulesTab.propTypes = {
	onChange: PropTypes.func.isRequired,
	parentQuestionConfig: PropTypes.any.isRequired,
	completeFormModel: PropTypes.any.isRequired,
	ruleType: PropTypes.oneOf([ "visible", "enable", "ignore" ]).isRequired,
};


export default RulesTab;
